import { EndpointBuilder } from "@reduxjs/toolkit/query";
import { HTTP_METHODS } from "@src/constants";
import { baseApiSlice } from "@src/services/apis/baseApiSlice";
import { CreateDepartmentPayload, Department } from "@src/types";
import { message } from "antd";

export const departmentsApi = baseApiSlice.injectEndpoints({
  endpoints: (builder: EndpointBuilder<any, any, any>) => ({
    /* GET endpoints */
    ...getEndpoints(builder),

    /* POST endpoints */
    ...postEndpoints(builder),
  }),
});

function getEndpoints(builder: EndpointBuilder<any, any, any>) {
  return {
    /**
     * Get departments
     */
    getN1Departments: builder.query<Department[], void>({
      query: () => "/departments?departmentLevel=N1",
      transformErrorResponse: async () => {
        message.error("Unable to load N-1 departments", 5);
      },
    }),

    getDepartments: builder.query<Department[], void>({
      query: () => "departments",
      transformErrorResponse: async () => {
        message.error("Failed to get department list", 5);
      },
      providesTags: ["Departments"],
    }),
  };
}

function postEndpoints(builder: EndpointBuilder<any, any, any>) {
  const baseMethod = HTTP_METHODS.POST;

  return {
    /**
     * Create a new department
     */
    createDepartment: builder.mutation<Department, CreateDepartmentPayload>({
      query: (request) => ({
        method: baseMethod,
        body: request,
        url: "departments",
      }),
      transformErrorResponse: async () => {
        message.error("Error creating department", 5);
      },
      invalidatesTags: ["Departments"],
    }),
  };
}

export const {
  /* GET endpoints */
  useGetN1DepartmentsQuery,
  useGetDepartmentsQuery,
  useLazyGetDepartmentsQuery,

  /* POST endpoints */
  useCreateDepartmentMutation,
} = departmentsApi;
